// extracted by mini-css-extract-plugin
export default {"container":"PageContainer__container___T6MGl"};